<div class="main-container">
    <div class="ui grid">
        <div class="sixteen wide column">
            <h1><i class="setting icon"></i> Settings</h1>
        </div>

        <!-- Sidebar Menu -->
        <div
            class="sixteen wide mobile four wide tablet four wide computer column settings-side-menu"
        >
            <app-setting-sidebar active_tab="display"> </app-setting-sidebar>
        </div>

        <div
            class="sixteen wide mobile twelve wide tablet twelve wide computer column settings-main-content"
        >
            <div class="ui top attached tabular menu">
                <div class="item active" data-tab="first" v-if="!isOnSiteUser">
                    Displayed Details
                </div>
                <div class="item" data-tab="second">Email Templates</div>
            </div>

            <app-form-error></app-form-error>

            <!-- Tab 1 -->
            <div class="ui bottom attached tab segment active" data-tab="first" v-if="!isOnSiteUser">
                <form class="ui form settings">

                    <div class="field settings">
                        The information below will be displayed on all external
                        documents sent from your account.<br />
                    </div>

                    <h4 class="ui dividing header">
                        Business Details
                    </h4>

                    <div class="two fields">
                        <div class="field settings">
                            <label>Business Name*</label>
                            <app-text-input
                                placeholder="Enter Business Name"
                                type="text"
                                v-model="settings.business_name" :error="validation('business_name')"
                            />
                        </div>
                        <div class="field settings">
                            <label>Business ABN</label>
                            <app-text-input
                                placeholder="Enter ABN"
                                type="text"
                                v-model="settings.abn" :error="validation('abn')"
                            />
                        </div>
                    </div>

                    <div class="two fields">
                        <div class="field settings">
                            <label>Business Phone</label>
                            <app-text-input
                                placeholder="Enter Phone Number"
                                type="text"
                                v-model="settings.phone" :error="validation('phone')"
                            />
                        </div>
                        <div class="field settings">
                            <label>Business Email</label>
                            <app-text-input
                                placeholder="Enter Email Address"
                                type="email"
                                v-model="settings.email" :error="validation('email')"
                            />
                        </div>
                    </div>

                    <div class="field settings">
                        <label>Branding / Logo</label>
                        <div class="upload-displayed-logo">
                            <app-images
                                :parent_item="settings"
                                :save="saveSettings"
                                :resize="false"
                                @images="settings.images = $event"
                            ></app-images>
                        </div>
                    </div>

                    <div
                        class="ui primary button settings-save-btn"
                        v-on:click="saveSettings"
                    >
                        Save Changes
                    </div>

                    <h4 class="ui dividing header">
                        Business Address
                    </h4>

                    <div class="one field">
                        <div class="field settings">
                            <label>Street Address</label>
                            <app-text-input
                                placeholder="Enter Street Address"
                                type="text"
                                v-model="settings.address.address_line_1" :error="validation('address_line_1')"
                            />
                        </div>
                        <!--<div class="field settings">-->
                        <!--<label>Address Line 2</label>-->
                        <!--<input placeholder="Enter Unit or Apartment #" type="text" v-model="settings.address.address_line_2" v-bind:class="{ error:validation('address_line_2') }">-->
                        <!--</div>-->
                    </div>
                    <div class="three fields">
                        <div class="field settings">
                            <label>Suburb</label>
                            <app-text-input
                                placeholder="Enter Suburb"
                                type="text"
                                v-model="settings.address.suburb" :error="validation('suburb')"
                            />
                        </div>

                        <div class="field settings">
                            <label>Postcode</label>
                            <app-text-input
                                placeholder="Enter Postcode"
                                type="text"
                                v-model="settings.address.post_code" :error="validation('post_code')"
                            />
                        </div>

                        <div class="field settings">
                            <label>State</label>
                            <app-select
                                :defaultLabel="'Select state'"
                                :items="$store.getters['getStates']"
                                :value="settings.address.state || ''"
                                @selected="settings.address.state = $event.id"
                            >
                            </app-select>
                        </div>
                    </div>

                    <div
                        class="ui primary button settings-save-btn"
                        v-on:click="saveSettings"
                    >
                        Save Changes
                    </div>

                    <h4 class="ui dividing header">
                        Additional Details
                    </h4>

                    <h4>Quotes</h4>
                    <div class="two fields">
                        <div class="field settings eight wide column">
                            <app-field-label html-for="quote_validity_days">Default Expiry Date</app-field-label>
                            <div class="ui right labeled input">
                                <input
                                    id="quote_validity_days"
                                    type="number"
                                    min="1"
                                    step="1"
                                    v-model.number="settings.quote_validity_days"
                                >
                                <div class="ui label">days</div>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <div class="field settings">
                            <label>Terms and Conditions</label>
                            <textarea
                                rows="4"
                                v-model="settings.quote_terms"
                            ></textarea>
                        </div>
                    </div>

                    <div
                        class="ui primary button settings-save-btn"
                        v-on:click="saveSettings"
                    >
                        Save Changes
                    </div>

                    <!--<div class="ui secondary button settings-save-btn">
            Preview Quote
          </div>-->

                    <div class="ui divider"></div>

                    <h4>Invoices</h4>
                    <div class="two fields">
                        <div class="field settings eight wide column">
                            <app-field-label html-for="invoice_due_days">Default Due Date</app-field-label>
                            <div class="ui right labeled input">
                                <input
                                    id="invoice_due_days"
                                    type="number"
                                    min="1"
                                    step="1"
                                    v-model.number="settings.invoice_due_days"
                                >
                                <div class="ui label">days</div>
                            </div>
                        </div>
                    </div>
                    <div class="field">
                        <div class="field settings">
                            <label>Terms and Conditions</label>
                            <textarea
                                rows="4"
                                v-model="settings.invoice_terms"
                            ></textarea>
                        </div>
                        <!-- <div class="field settings">
              <label>Payment Details</label>
              <textarea rows="15" v-model="settings.invoice_payment_details"></textarea>
            </div> -->
                    </div>

                    <div
                        class="ui primary button settings-save-btn"
                        v-on:click="saveSettings"
                    >
                        Save Changes
                    </div>

                    <!--<div class="ui secondary button settings-save-btn">
            Preview invoice
          </div>-->
                </form>
            </div>

            <!-- Tab 2 -->
            <div class="ui bottom attached tab segment" data-tab="second">
                <form class="ui form settings">

                    <div class="field settings">
                        The information below will be displayed in the emails
                        sent from your account.<br />
                    </div>

                    <h4>Quotes</h4>
                    <div class="field">
                        <div class="field settings">
                            <div class="ui icon tooltip" data-variation="basic" data-content="Placeholders: [Customer First Name], [Customer Last Name], [Quote Number], [Quote Total Amount], [Company Name], [Quote-Terms]">
                                <label>Quote Message
                                    <i class="question circle outline icon"></i>
                                </label>
                            </div>
                            <textarea
                                rows="15"
                                v-model="templates.quote_message"
                            ></textarea>
                        </div>

                        <div class="field settings"></div>
                    </div>

                    <div
                        class="ui primary button settings-save-btn"
                        v-on:click="saveTemplates"
                    >
                        Save Changes
                    </div>

                    <!--          <div class="ui secondary button settings-save-btn">
            Send Test Email
          </div>-->

                    <div class="ui divider"></div>

                    <h4>Invoices</h4>
                    <div class="field">
                        <div class="field settings">
                            <div class="ui icon tooltip" data-variation="basic" data-content="Placeholders: [Customer First Name], [Customer Last Name], [Number], [Total Amount], [Company Name], [Invoice-Terms]">
                                <label>Invoice Message
                                    <i class="question circle outline icon"></i>
                                </label>
                            </div>
                            <textarea
                                rows="15"
                                v-model="templates.invoice_message"
                            ></textarea>
                        </div>

                        <div class="field settings"></div>
                    </div>

                    <div
                        class="ui primary button settings-save-btn"
                        v-on:click="saveTemplates"
                    >
                        Save Changes
                    </div>

                    <!--          <div class="ui secondary button settings-save-btn">
            Send Test Email
          </div>-->
                </form>
            </div>
        </div>
    </div>
</div>
